import React from 'react';
import { Box, Typography, Container, Button } from '@mui/material';
import { motion } from 'framer-motion';
import { MdConstruction, MdFavorite, MdShoppingCart, MdAttachMoney, MdTravelExplore, MdShield } from 'react-icons/md';
import './VerticalSolutionsSection.css';
import '../styles/SectionTitles.css';

const solutions = [
  {
    title: 'Construction',
    desc: 'Advanced mobile app solutions that take Construction into the Digital Era.',
    icon: <MdConstruction size={32} />, // will use theme color via CSS
    link: '#',
    iconClass: 'construction'
  },
  {
    title: 'Health',
    desc: 'Patient-friendly mobile software that empowers healthcare industry workers.',
    icon: <MdFavorite size={32} />, // will use theme color via CSS
    iconClass: 'health'
  },
  {
    title: 'Retail & eCommerce',
    desc: 'Engaging mobile software solutions for modern retail.',
    icon: <MdShoppingCart size={32} />, // will use theme color via CSS
    iconClass: 'retail'
  },
  {
    title: 'FinTech',
    desc: 'Meet the demands of modern customers in speed and security with scalable financial technology.',
    icon: <MdAttachMoney size={32} />, // will use theme color via CSS
    iconClass: 'fintech'
  },
  {
    title: 'Logistics & Supply Chain',
    desc: 'Optimize your logistics and supply chain operations with smart, scalable mobile solutions.',
    icon: <MdTravelExplore size={32} />, // can be replaced with a more relevant icon if available
    iconClass: 'logistics'
  },
  {
    title: 'Insurance',
    desc: 'Boost the profitability and safety of your business processes through innovative mobile app solutions.',
    icon: <MdShield size={32} />, // will use theme color via CSS
    iconClass: 'insurance'
  },
];

const VerticalSolutionsSection = () => (
  <Box className="vertical-solutions-root">
    <Container maxWidth="lg">
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
      <Box className="vertical-solutions-header">
          <Box className="section-title-row">
            <Typography variant="h3" className="section-title-gradient">
            Industry Solutions
          </Typography>
            <span className="section-title-line" />
        </Box>
          <Typography variant="h6" className="section-subtitle">
          From startups to enterprises, we've gained vast experience in delivering innovative digital solutions for a wide range of clients across multiple industries.
        </Typography>
      </Box>
      </motion.div>
      <Box className="vertical-solutions-grid">
        {solutions.map((sol, idx) => (
          <motion.div
            key={sol.title}
            initial={{ opacity: 0, y: 100 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ 
              duration: 0.8,
              delay: idx * 0.1,
              ease: 'easeOut'
            }}
          >
            <Box className="vertical-solution-card" style={{ alignItems: 'center', justifyContent: 'flex-start' }}>
              <span className={`vertical-solution-icon ${sol.iconClass}`}>{sol.icon}</span>
              <Typography variant="h5" className="vertical-solution-card-title" style={{ textAlign: 'center' }}>
                {sol.title}
              </Typography>
              <Typography className="vertical-solution-card-desc" style={{ textAlign: 'center' }}>
                {sol.desc}
              </Typography>
              {/* {idx === 0 && (
                <Button className="vertical-solution-btn" variant="text" size="large" endIcon={<span>&#8594;</span>}>
                  VIEW MORE
                </Button>
              )} */}
            </Box>
          </motion.div>
        ))}
      </Box>
    </Container>
  </Box>
);

export default VerticalSolutionsSection;

// Add this below the export for usage in parent or Home.js
// import ProcessStepsSection from './ProcessStepsSection'; 